import axios from "axios";
import authHeader from "./auth-header";

require('dotenv').config();

const addPedidoEmpleado = (pedido_empleado) => {
  return axios.post(process.env.REACT_APP_URL + "/api/pedido_empleado/",{pedido_empleado},{ headers: authHeader() });
};

const getPedidosPorCliente = async (idCliente) => {
  const resultado = await axios.get(process.env.REACT_APP_URL  + "/api/pedido_empleado/search/" + idCliente, { headers: authHeader() });
  return resultado;
}


const PedidoEmpleadoService = {
    addPedidoEmpleado,
    getPedidosPorCliente
};

export default PedidoEmpleadoService;
